export const PACKAGE_NAME = 'jira-admin-pages-issue-hierarchy-directory';
export const TEAM_NAME = 'advanced-roadmaps';
export const METRICS_PAGE_ID = 'global-admin.issues.issue-hierarchy-config';

/**
 * Maximum level number where a standard user can add an issue type to a level
 */
export const MAX_HIERARCHY_LEVEL_STANDARD_USER_CAN_ADD_ISSUE_TYPE = 0;
/**
 * Maximum level number where a standard user can rename a level
 */
export const MAX_HIERARCHY_LEVEL_STANDARD_USER_RENAMABLE = 1;
/**
 * Maximum level number where a standard user can remove issue type from a level
 */
export const MAX_HIERARCHY_LEVEL_STANDARD_USER_REMOVABLE = 1;
/**
 * These are "default" levels, where we do not store or send the issue-types back
 * They will need to be pruned from the GQL when being loaded into the page
 */
export const HIERARCHY_LEVELS_TO_IGNORE_ISSUE_TYPES = [-1, 0];

/**
 * Lowest Level
 */
export const LOWEST_LEVEL = -1;

/**
 * Levels that cannot be shuffled
 */
export const STATIC_LEVELS = Object.freeze({
	from: LOWEST_LEVEL,
	to: MAX_HIERARCHY_LEVEL_STANDARD_USER_REMOVABLE,
});

/**
 * from -1 to 1 there is 3
 */

export const NUM_STATIC_LEVELS = 1 + STATIC_LEVELS.to - STATIC_LEVELS.from;

export const JIRA_LONG_RUNNING_TASK_STATUS = {
	RUNNING: 'RUNNING',
	ENQUEUED: 'ENQUEUED',
	FAILED: 'FAILED',
	DEAD: 'DEAD',
	COMPLETE: 'COMPLETE',
	CANCELLED: 'CANCELLED',
	CANCEL_REQUESTED: 'CANCEL_REQUESTED',
};

/**
 * The status of task which update the hierarchy
 */

export const UPDATE_HIERARCHY_TASK_STATUS = {
	RUNNING: 'RUNNING',
	FAILED: 'FAILED',
	COMPLETED: 'COMPLETED',
	NULL: 'NULL',
} as const;

export const DOC_LINKS = {
	LEARN_MORE:
		'https://support.atlassian.com/jira-cloud-administration/docs/configure-the-issue-type-hierarchy/',
	CONTACT_SUPPORT: 'https://support.atlassian.com/contact',
	CONFIGURE_ISSUE_TYPE_HIERARCHY:
		'https://support.atlassian.com/jira-cloud-administration/docs/configure-the-issue-type-hierarchy/',
};
